/* __next_internal_client_entry_do_not_use__ AppSignUpPageResultsProvider,TestAppSignUpPageResultsProvider,useAppSignUpPageResults,useAppSignUpPageResultsUpdateEffect auto */ import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";
import React from "react";
var INITIAL_CONTEXT_VALUE = {};
var _createContextStore = createContextStore(INITIAL_CONTEXT_VALUE), useStore = _createContextStore.useStore, Provider = _createContextStore.Provider;
export var AppSignUpPageResultsProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(Provider, {
        children: children
    });
};
export var TestAppSignUpPageResultsProvider = function(param) {
    var children = param.children, value = param.value;
    return /*#__PURE__*/ _jsx(Provider, {
        value: value,
        children: children
    });
};
export var useAppSignUpPageResults = function() {
    var _useStore = _sliced_to_array(useStore([
        "productTiles",
        "suppliersPageBrands",
        "pdpProduct",
        "productBasedCollection"
    ]), 1), state = _useStore[0];
    return state;
};
export var useAppSignUpPageResultsUpdateEffect = function(results) {
    var _useStore = _sliced_to_array(useStore([]), 2), _ = _useStore[0], setContext = _useStore[1];
    var productTiles = results.productTiles, suppliersPageBrands = results.suppliersPageBrands, pdpProduct = results.pdpProduct, productBasedCollection = results.productBasedCollection;
    React.useEffect(function() {
        setContext({
            productTiles: productTiles,
            suppliersPageBrands: suppliersPageBrands,
            pdpProduct: pdpProduct,
            productBasedCollection: productBasedCollection
        });
    }, [
        setContext,
        productTiles,
        suppliersPageBrands,
        pdpProduct,
        productBasedCollection
    ]);
    React.useEffect(function() {
        return function() {
            // When page unmounts, let data be garbage collected.
            setContext(INITIAL_CONTEXT_VALUE);
        };
    }, [
        setContext
    ]);
};
